'use strict';

// Material workspace — the materials catalog hub. Config-only. The Suppliers tab reuses the bespoke
// MaterialOrganization association editor (inline expiry date); Pay Items is the Material↔PayItem cross-entity tool.

const libMaterialOrgEditor = require('../views/MaterialOrganizationAssociationEditor.js');

module.exports = {
	Identifier: 'MaterialWorkspace',
	Ordinal: 241,
	Entity: { Name: 'Material', IDField: 'IDMaterial', Collection: 'Materials', GUIDField: 'GUIDMaterial' },
	Header:
	{
		Eyebrow: 'Material',
		Title: (pRec) => pRec.Name || `Material ${pRec.IDMaterial}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ],
		ListRoute: '#/PSRS/Material/List',
	},
	EditorLibs: { MaterialOrganizationEditor: libMaterialOrgEditor },
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'payitems', Label: 'Pay Items', Icon: 'fas fa-dollar-sign', Content: { kind: 'assoc', ref: 'MaterialPayItem' } },
		{ Key: 'testspecs', Label: 'Test Specifications', Icon: 'fas fa-vial', Content: { kind: 'assoc', ref: 'MaterialTestSpecification' } },
		{ Key: 'mixspecs', Label: 'Mix Specifications', Icon: 'fas fa-file-lines', Content: { kind: 'assoc', ref: 'MaterialMixSpecification' } },
		{ Key: 'suppliers', Label: 'Suppliers', Icon: 'fas fa-truck', Content: { kind: 'assoc', ref: 'MaterialOrganization', editorLib: 'MaterialOrganizationEditor' } },
		{ Key: 'lineitems', Label: 'Line Items', Icon: 'fas fa-list-ul', Content: { kind: 'assoc', ref: 'LineItemMaterial' } },
		{ Key: 'mixdesigns', Label: 'Mix Designs', Icon: 'fas fa-flask-vial', Content: { kind: 'childlist', ref: 'MixDesign', parentField: 'IDMaterial',
			columns: [ { Key: 'Name', Label: 'Name' }, { Key: 'MaterialCode', Label: 'Material Code' }, { Key: 'Description', Label: 'Description' } ], empty: 'No mix designs use this material.' } },
		{ Key: 'products', Label: 'Products', Icon: 'fas fa-box', Content: { kind: 'childlist', ref: 'Product', parentField: 'IDMaterial',
			columns: [ { Key: 'Name', Label: 'Name' }, { Key: 'ManufacturerCode', Label: 'Mfr Code' }, { Key: 'CatalogCode', Label: 'Catalog Code' } ], empty: 'No products of this material.' } },
		{ Key: 'samples', Label: 'Samples', Icon: 'fas fa-vial', Content: { kind: 'childlist', ref: 'Sample', parentField: 'IDMaterial',
			columns: [ { Key: 'LabControlNumber', Label: 'PSID' }, { Key: 'Name', Label: 'Description' }, { Key: 'ReceivedFrom', Label: 'Source' } ], empty: 'No samples of this material.', cap: 200 } },
	],
	FieldGroups:
	[
		{ Name: 'Identity', Fields: [
			{ Key: 'Name', Label: 'Name', Wide: true },
			{ Key: 'NameAbbreviated', Label: 'Abbreviation' },
			{ Key: 'Type', Label: 'Type' },
			{ Key: 'MaterialCode', Label: 'Material Code', Mono: true },
			{ Key: 'CatalogCode', Label: 'Catalog Code', Mono: true },
			{ Key: 'Description', Label: 'Description', Wide: true },
		] },
	],
};
